import { render, staticRenderFns } from "./adminCountsBase.vue?vue&type=template&id=c07b63b0&scoped=true&"
import script from "./adminCountsBase.vue?vue&type=script&lang=js&"
export * from "./adminCountsBase.vue?vue&type=script&lang=js&"
import style0 from "./adminCountsBase.vue?vue&type=style&index=0&id=c07b63b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07b63b0",
  null
  
)

export default component.exports